import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "quantity-controller quantity-controller--container" }
const _hoisted_2 = {
  key: 0,
  class: "quantity-controller--controls-container",
  "data-cy": "quantity-controller"
}
const _hoisted_3 = {
  key: 1,
  class: "quantity-controller--controls-container icons",
  "data-cy": "quantity-controller"
}
const _hoisted_4 = {
  class: "quantity-controller--value",
  "data-cy": "controller-value"
}
const _hoisted_5 = {
  key: 2,
  class: "quantity-controller--controls-container",
  "data-cy": "quantity-controller"
}
const _hoisted_6 = {
  key: 3,
  class: "quantity-controller--controls-container default",
  "data-cy": "quantity-controller"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_ctx.controls === 'icons')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "quantity-controller--control-increase",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.value = Math.min(_ctx.max || (parseInt(_ctx.value) + _ctx.step), Math.max(_ctx.min || (parseInt(_ctx.value) + _ctx.step), parseInt(_ctx.value) + _ctx.step))), ["stop"])),
              "data-cy": "controller-increase"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "t-icon" }, "k", -1)
            ])),
            _createElementVNode("div", {
              class: "quantity-controller--control-decrease",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.value = Math.min(_ctx.max || (parseInt(_ctx.value) - _ctx.step), Math.max(_ctx.min || (parseInt(_ctx.value) - _ctx.step), parseInt(_ctx.value) - _ctx.step))), ["stop"])),
              "data-cy": "controller-decrease"
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "t-icon" }, "l", -1)
            ]))
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "value", { value: _ctx.value }, () => [
        _createElementVNode("span", null, _toDisplayString(_ctx.value), 1)
      ], true)
    ]),
    (_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : (_ctx.controls === 'default')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "quantity-controller--control-increase",
              style: _normalizeStyle({borderWidth: `${_ctx.controlSize}px`}),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.value = Math.min(_ctx.max || (parseInt(_ctx.value) + _ctx.step), Math.max(_ctx.min || (parseInt(_ctx.value) + _ctx.step), parseInt(_ctx.value) + _ctx.step))), ["stop"])),
              "data-cy": "controller-increase"
            }, null, 4),
            _createElementVNode("div", {
              class: "quantity-controller--control-decrease",
              style: _normalizeStyle({borderWidth: `${_ctx.controlSize}px`}),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.value = Math.min(_ctx.max || (parseInt(_ctx.value) - _ctx.step), Math.max(_ctx.min || (parseInt(_ctx.value) - _ctx.step), parseInt(_ctx.value) - _ctx.step))), ["stop"])),
              "data-cy": "controller-decrease"
            }, null, 4)
          ]))
        : _createCommentVNode("", true)
  ]))
}